<template>
    <WrHeader />
</template>
<script setup>
// import WrHeader from '~/components/global/WrHeader.vue';

const WrHeader = defineAsyncComponent(() => import('~/components/molecules/WrHeader.vue'));

definePageMeta({
    layout: false,
})
</script>